interface Props {
  label: string;
  color?: string | null;
  onClick?: () => void;
  onRemove?: () => void;
  size?: 'xs' | 'sm';
  title?: string;
}

const PALETTE: ReadonlyArray<{ name: string; cls: string }> = [
  { name: 'rose',     cls: 'bg-rose-100 text-rose-700 dark:bg-rose-900/30 dark:text-rose-300' },
  { name: 'amber',    cls: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300' },
  { name: 'lime',     cls: 'bg-lime-100 text-lime-700 dark:bg-lime-900/30 dark:text-lime-300' },
  { name: 'emerald',  cls: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300' },
  { name: 'cyan',     cls: 'bg-cyan-100 text-cyan-700 dark:bg-cyan-900/30 dark:text-cyan-300' },
  { name: 'sky',      cls: 'bg-sky-100 text-sky-700 dark:bg-sky-900/30 dark:text-sky-300' },
  { name: 'indigo',   cls: 'bg-indigo-100 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-300' },
  { name: 'fuchsia',  cls: 'bg-fuchsia-100 text-fuchsia-700 dark:bg-fuchsia-900/30 dark:text-fuchsia-300' },
];

export const TAG_COLORS = PALETTE.map(p => p.name);

function hashClass(label: string): string {
  let hash = 0;
  for (let i = 0; i < label.length; i++) {
    hash = (hash * 31 + label.charCodeAt(i)) >>> 0;
  }
  return PALETTE[hash % PALETTE.length].cls;
}

function resolveColorClass(label: string, color?: string | null): string {
  if (color) {
    const preset = PALETTE.find(p => p.name === color);
    if (preset) return preset.cls;
  }
  return hashClass(label);
}

export function Chip({ label, color, onClick, onRemove, size = 'xs', title }: Props) {
  const sizeCls = size === 'xs' ? 'text-xs px-1.5 py-0.5' : 'text-sm px-2 py-1';
  const colorCls = resolveColorClass(label, color);
  const interactive = onClick !== undefined;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded font-medium ${colorCls} ${sizeCls} ${interactive ? 'cursor-pointer hover:ring-1 hover:ring-current' : ''}`}
      onClick={onClick}
      title={title ?? label}
    >
      {label}
      {onRemove && (
        <button
          type="button"
          onClick={e => { e.stopPropagation(); onRemove(); }}
          className="hover:opacity-70 -mr-0.5"
          aria-label={`Remove ${label}`}
        >
          ×
        </button>
      )}
    </span>
  );
}
